"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var screenfull = require("screenfull");
var _ = require("lodash");
var tippy = require('tippy.js').default;
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var commentUtils_1 = require("../utils/commentUtils");
var metrikaUtils_1 = require("../../app/utils/metrikaUtils");
var localStorageUtils_1 = require("../../app/utils/localStorageUtils");
var baseViewModel_1 = require("./base/baseViewModel");
var cookieUtils_1 = require("../../app/utils/cookieUtils");
var readingProgressUtils_1 = require("../../app/utils/readingProgressUtils");
var Settings = (function () {
    function Settings() {
    }
    return Settings;
}());
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.minFontSize = 1;
        this.maxFontSize = 30;
        this.minFieldSize = 1;
        this.maxFieldSize = 7;
        this.minLineHeight = 1;
        this.maxLineHeight = 5;
        this.minBrightness = 1;
        this.maxBrightness = 5;
        this.animationTime = 1920 * 2;
        this.$markPopover = $("#markPopover");
        this.$morePopover = $("#popoverMore");
        this.backHistoryAfterClose = true;
        this.voteId = ko.observable();
        this.libraryId = ko.observable();
        this.isInLibrary = ko.pureComputed(function () {
            return !!_this.libraryId();
        });
        this.isLiked = ko.pureComputed(function () {
            return !!_this.voteId();
        });
        this.processing = ko.observable(false);
        this.$reader = $("#reader");
        this.$textWrapper = $(".text-wrapper");
        this.isLoading = ko.observable(true);
        this.isInit = false;
        this.showUnauthorizedForm = ko.observable(false);
        this.showSuspendedForm = ko.observable(false);
        this.showBuyForm = ko.observable(false);
        this.showCommentForm = ko.observable(false);
        this.showUnadultedForm = ko.observable(false);
        this.showContent = ko.pureComputed(function () {
            return !_this.showUnauthorizedForm()
                && !_this.showSuspendedForm()
                && !_this.showBuyForm()
                && !_this.showUnadultedForm();
        });
        this.readerMode = ko.observable("scroll");
        this.workInfoMode = ko.observable("workDetails");
        this.visibleLeftPanel = ko.observable(false);
        this.visibleRightPanel = ko.observable(false);
        this.controlsIsVisible = ko.observable(true);
        this.pdaMenuIsVisible = ko.observable(false);
        this.isDisabled = ko.pureComputed(function () {
            return (_this.visibleLeftPanel() || _this.visibleRightPanel());
        });
        this.currentChapterId = ko.observable();
        this.chapters = ko.observableArray();
        this.totalTextLength = ko.pureComputed(function () {
            var length = 0;
            _.each(_this.chapters(), function (c) {
                length += c.textLength;
            });
            return length;
        });
        this.readTextLength = ko.observable(0);
        this.isFullScreenMode = ko.observable(false);
        this.fontList = ["Roboto", "Verdana", "Georgia", "Arial", "Alegreya", "Times New Roman", "Comfortaa", "Fira Sans", "PT Sans"];
        this.fontListIsOpen = ko.observable(false);
        this.fontPickerIcon = ko.pureComputed(function () {
            return _this.fontListIsOpen() ? "fa-angle-up" : "fa-angle-down";
        });
        this.fontSize = ko.observable();
        this.fieldSize = ko.observable();
        this.lineHeight = ko.observable();
        this.fontFamily = ko.observable();
        this.brightness = ko.observable();
        this.customColorScheme = ko.observable();
        this.customFontColor = ko.observable();
        this.customBackgroundColor = ko.observable();
        this.hyphenation = ko.observable();
        this.workMarks = ko.observableArray();
        this.priceWithDiscounts = ko.observable();
        this.priceWithDiscountsText = ko.pureComputed(function () {
            var discountFormatText = _this.discount ? " (-" + _this.discount + "%)" : '';
            return 'Купить за ' + _this.priceWithDiscounts() + discountFormatText;
        });
        this.bodyClass = ko.computed(function () {
            var brightness = _this.brightness();
            var customColorScheme = _this.customColorScheme();
            var customFontColor = _this.customFontColor();
            var customBackgroundColor = _this.customBackgroundColor();
            var css = "";
            if (customColorScheme) {
                var color = customBackgroundColor.substring(1); // strip #
                var rgb = parseInt(color, 16); // convert rrggbb to decimal
                var r = (rgb >> 16) & 0xff; // extract red
                var g = (rgb >> 8) & 0xff; // extract green
                var b = (rgb >> 0) & 0xff; // extract blue
                var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
                if (luma < 40) {
                    css += "dark-theme";
                }
                else {
                    css += "light-theme";
                }
                $("#reader").css("color", customFontColor);
                $("#reader").css("background-color", customBackgroundColor);
            }
            else {
                css += "brightness-" + brightness;
                $("#reader").css("color", "");
                $("#reader").css("background-color", "");
            }
            if (_this.readerMode() === "scroll") {
                css += " scroll-mode";
            }
            $("body").attr("class", css);
        });
        this.textWrapperClass = ko.pureComputed(function () {
            var fieldSize = _this.fieldSize();
            return "field-size-" + fieldSize;
        });
        this.currentChapter = ko.pureComputed(function () {
            var id = _this.currentChapterId();
            return _.find(_this.chapters(), function (c) {
                return c.id === id;
            });
        });
        this.lastNormalPercent = 0;
        this.progressPercent = ko.pureComputed(function () {
            var currentChapter = _this.currentChapter();
            if (!currentChapter)
                return 0;
            var chapterReadTextLength = currentChapter.textLength * _this.chapterProgressPercent();
            var totalReadTextLength = _this.readTextLength() + chapterReadTextLength;
            var percent = totalReadTextLength * 100 / _this.totalTextLength();
            if (_this.isLoading()) {
                percent = _this.lastNormalPercent;
            }
            else {
                _this.lastNormalPercent = percent;
            }
            return percent;
        });
        this.prevChapter = ko.pureComputed(function () {
            var index = _this.chapters().indexOf(_this.currentChapter());
            index--;
            if (index < 0)
                return null;
            return _this.chapters()[index];
        });
        this.nextChapter = ko.pureComputed(function () {
            var chapters = _this.chapters();
            var index = _this.chapters().indexOf(_this.currentChapter());
            index++;
            if (index >= chapters.length)
                return null;
            return _this.chapters()[index];
        });
        this.isLastChapter = ko.pureComputed(function () {
            return _this.nextChapter() == null;
        });
        this.isLitmobCarouselVisible = ko.observable(false);
        this.progressUpdated = true;
        this.progressPercentComputed = ko.pureComputed(function () {
            _this.progressUpdated = false;
            return _this.progressPercent();
        }).extend({
            rateLimit: {
                timeout: app.isAuthenticated ? 3000 : 30000,
                method: app.isAuthenticated ? "notifyWhenChangesStop" : "notifyAtFixedRate"
            }
        });
        this.textContainerStyle = ko.pureComputed(function () {
            if (_this.showBuyForm())
                return "";
            var fontSize = 10 + _this.fontSize();
            var lineHeight = 0.9 + _this.lineHeight() * 0.15;
            return "font-family: " + _this.fontFamily() + ";\n            line-height: " + lineHeight + "em !important;\n            font-size: " + fontSize + "px";
        });
        this.goToChapter = function (chapter) {
            _this.showBuyForm(false);
            _this.showUnauthorizedForm(false);
            _this.showSuspendedForm(false);
            _this.showUnadultedForm(false);
            _this.currentChapterId(chapter.id);
        };
        this.toggleMark = function (mark, viewModel, event) {
            if (_this.processing())
                return;
            _this.processing(true);
            var $img = $(event.target);
            $img.attr("src", $img.attr("data-animated-src"));
            setTimeout(function () {
                $img.attr("src", $img.attr("data-src"));
            }, _this.animationTime);
            var isActive = _this.workMarks().indexOf(mark) === -1;
            ajaxUtils_1.AjaxUtils.post("work/mark", {
                workId: _this.workId,
                isActive: isActive,
                mark: mark
            }).done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.workMarks(result.data.marks);
            }).always(function () {
                _this.processing(false);
            });
        };
        this.markEnumToCode = function (enumValue) {
            var mark = _.find(_this.options.allMarks, function (x) {
                return x.enumValue === enumValue;
            });
            if (mark)
                return mark.code;
            return "unknown";
        };
        this.hyphenopoly = options.hyphenopoly;
        this.workId = options.workId;
        this.workTitle = options.workTitle;
        this.workForm = options.workForm;
        this.authorName = options.authorName;
        this.nextSeriesWorkId = options.nextSeriesWorkId;
        this.libraryId(options.libraryId);
        this.voteId(options.voteId);
        this.sessionId = options.sessionId;
        this.epilog = options.epilog;
        if (app.userId && options.useReadingProgress) {
            readingProgressUtils_1.default.check(app.userId, this.workId, options.chapterId, options.chapterProgress);
        }
        localStorageUtils_1.default.addToList(localStorageUtils_1.default.RecentlyViewedKey, options.workId);
        this.loadSettings();
        this.hanleUserInput();
        this.chapterProgressPercent = ko.observable();
        this.chapters(options.chapters);
        this.currentChapterId(options.chapterId);
        this.currentChapterId.subscribe(function (chapterId) {
            if (!_this.isInit)
                return;
            _this.loadChapter(chapterId);
        });
        this.workMarks(options.workMarks || []);
        $(window).on("popstate", function () {
            _this.backHistoryAfterClose = false;
            _this.closeMarkPopover();
        });
        setTimeout(function () {
            _this.loadChapter(options.chapterId, false, options.chapterProgress);
            setTimeout(function () {
                _this.isInit = true;
            }, 1000);
        }, 50);
        this.progressPercentComputed.subscribe(function () {
            _this.updateReadingProgress();
        });
        try {
            if (screenfull.enabled) {
                screenfull["on"]("change", function () {
                    _this.isFullScreenMode(screenfull.isFullscreen);
                });
            }
            else {
                $("#btnFullScreen").hide();
            }
        }
        catch (ex) {
            // Safari iOS не поддерживает режим полного экрана
            $("#btnFullScreen").hide();
        }
        this.isLoading.subscribe(function (value) {
            if (!value && _this.settings.hyphenation) {
                try {
                    _this.loadHyphenopoly();
                }
                catch (ex) {
                    alert("Перенос слов не работает на вашем устройстве!");
                    _this.hyphenation(false);
                    _this.settings.hyphenation = false;
                    localStorageUtils_1.default.set("reader.settings", _this.settings);
                }
            }
        });
        var tippeEls = this.$markPopover.find("button[data-hint]").toArray()
            .concat($(".marks-line-bar button[data-hint]").toArray());
        this.createTippy(tippeEls);
        if (this.isLastChapter()) {
            this.updateLitmobSlider();
        }
        this.isLastChapter.subscribe(function (value) {
            if (value) {
                _this.updateLitmobSlider();
            }
            else {
                _this.isLitmobCarouselVisible(false);
            }
        });
    }
    ViewModel.prototype.toggleLike = function () {
        var _this = this;
        if (!app.ensureAuth("Вам необходимо авторизоваться")) {
            return;
        }
        if (this.processing())
            return;
        this.processing(true);
        ajaxUtils_1.AjaxUtils.post("work/like", {
            targetId: this.workId,
            isLiked: !this.isLiked(),
            voteId: this.voteId()
        }).done(function (result) {
            if (result.isSuccessful) {
                _this.voteId(result.data.voteId);
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            _this.processing(false);
        });
    };
    ViewModel.prototype.toggleLibrary = function () {
        var _this = this;
        if (!app.ensureAuth("Чтобы добавить книгу в библиотеку, необходимо авторизоваться")) {
            return;
        }
        if (this.processing())
            return;
        this.processing(true);
        if (this.isInLibrary()) {
            ajaxUtils_1.AjaxUtils.post("work/removeFromLibrary", { id: this.libraryId() })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.libraryId(null);
            })
                .always(function () {
                _this.processing(false);
            });
        }
        else {
            ajaxUtils_1.AjaxUtils.post("work/addToLibrary", { workId: this.workId })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.libraryId(result.data);
            })
                .always(function () {
                _this.processing(false);
            });
            ;
        }
    };
    ViewModel.prototype.createTippy = function (els) {
        var self = this;
        setTimeout(function () {
            tippy(els, {
                content: function (c) { return c.getAttribute('data-hint'); },
                trigger: 'click',
                animation: 'scale',
                onShow: function (el) {
                    setTimeout(function () {
                        el.hide();
                    }, self.animationTime / 2);
                },
                zIndex: 14000
            });
        }, 0);
    };
    ViewModel.prototype.showSeriesNextWork = function () {
        var self = this;
        app.f7.confirm('Перейти к следующей книге цикла?', 'Книга закончилась', function () {
            window.location.replace("/reader/" + self.nextSeriesWorkId);
        });
    };
    ViewModel.prototype.updateLitmobSlider = function () {
        var _this = this;
        try {
            ajaxUtils_1.AjaxUtils.get("work/getOtherLitmobWorks", { workId: this.workId })
                .done(function (result) {
                if (!result.isSuccessful || result.data.count == 0) {
                    _this.isLitmobCarouselVisible(false);
                    return;
                }
                _this.isLitmobCarouselVisible(true);
                var $litmobSlider = $("#litmobSlider");
                var $sliderWrapper = $litmobSlider.find(".swiper-wrapper");
                $sliderWrapper.removeClass("work-slider-loading");
                $litmobSlider.addClass("work-slider");
                $sliderWrapper.html(result.data.html);
                var $swiperContainer = $litmobSlider.find(".swiper-container");
                var updateSwiperClass = function () {
                    setTimeout(function () {
                        if ($swiperContainer.find(".swiper-scrollbar").is(":hidden")) {
                            $litmobSlider.addClass("centeredSlider");
                        }
                        else {
                            $litmobSlider.removeClass("centeredSlider");
                        }
                    }, 100);
                };
                app.f7.swiper($swiperContainer[0], {
                    slidesPerView: "auto",
                    speed: 300,
                    slidesPerGroup: 3,
                    spaceBetween: 8,
                    grabCursor: true,
                    lazyLoading: false,
                    scrollbar: ".swiper-scrollbar",
                    onAfterResize: updateSwiperClass,
                    onInit: updateSwiperClass
                });
            }).fail(function () {
                _this.isLitmobCarouselVisible(false);
            });
        }
        catch (ex) {
            this.isLitmobCarouselVisible(false);
        }
    };
    /** Загрузка переносов в тексте */
    ViewModel.prototype.loadHyphenopoly = function () {
        this.hyphenopoly.config({
            require: {
                "ru": ""
            },
            setup: {
                keepAlive: true,
                selectors: {
                    "#text-container": {}
                }
            }
        });
    };
    ViewModel.prototype.hanleUserInput = function () {
        var _this = this;
        var time = 0;
        this.$reader.on("scroll.reader", function (event) {
            if ($.now() - time <= 500)
                return;
            time = $.now();
            var height = $("#text-container").height();
            var scrollTop = _this.$reader.scrollTop();
            _this.chapterProgressPercent(scrollTop / height);
        });
        $("#bookInfo").on("open.ko", function () {
            ko.applyBindingsToDescendants(_this, $("#bookInfo")[0]);
            $("#bookInfo").off("open.ko");
        });
        $("#bookInfo").on("closed.ko", function () {
            _this.workInfoMode("workDetails");
        });
        this.customColorScheme.subscribe(function (value) {
            if (value) {
                $("#readerSettings .picker-modal-inner").stop().animate({ scrollTop: $("#readerSettings .settings-container").height() }, {
                    duration: 300
                });
            }
        });
        $("#customBackgroudColorpicker").val(this.customBackgroundColor());
        $("#customBackgroudColorpicker").on("change", function () {
            _this.customBackgroundColor($("#customBackgroudColorpicker").val());
        });
        $("#customFontColorpicker").val(this.customFontColor());
        $("#customFontColorpicker").on("change", function () {
            _this.customFontColor($("#customFontColorpicker").val());
        });
    };
    ViewModel.prototype.loadSettings = function () {
        var _this = this;
        var settings = localStorageUtils_1.default.get("reader.settings");
        if (settings === null || settings === undefined) {
            settings = {
                brightness: $("html").is(".dark") ? 2 : 5,
                fontSize: 8,
                fieldSize: 6,
                lineHeight: 3,
                fontFamily: this.fontList[0],
                readerMode: "scroll",
                customColorScheme: false,
                customFontColor: "#444",
                customBackgroundColor: "#FFFFFF",
                version: "1.1",
                hyphenation: false
            };
        }
        if (settings.version === undefined || settings.version === null) {
            settings.fontSize = (settings.fontSize || 4) * 2;
            this.saveSettings();
        }
        else {
            this.settings = settings;
        }
        this.brightness(settings.brightness || 5);
        this.fontSize(settings.fontSize || 8);
        this.fieldSize(settings.fieldSize || 6);
        this.lineHeight(settings.lineHeight || 3);
        this.fontFamily(settings.fontFamily);
        this.readerMode("scroll");
        this.customColorScheme(settings.customColorScheme || false);
        this.hyphenation(settings.hyphenation || false);
        this.customFontColor(settings.customFontColor || "#444");
        this.customBackgroundColor(settings.customBackgroundColor || "#FFFFFF");
        this.brightness.subscribe(function () { return _this.saveSettings(); });
        this.fontSize.subscribe(function () { return _this.saveSettings(); });
        this.fieldSize.subscribe(function () { return _this.saveSettings(); });
        this.lineHeight.subscribe(function () { return _this.saveSettings(); });
        this.fontFamily.subscribe(function () { return _this.saveSettings(); });
        this.customColorScheme.subscribe(function () { return _this.saveSettings(); });
        this.hyphenation.subscribe(function () { return _this.saveSettings(); });
        this.customFontColor.subscribe(function () { return _this.saveSettings(); });
        this.customBackgroundColor.subscribe(function () { return _this.saveSettings(); });
    };
    ViewModel.prototype.saveSettings = function () {
        if (this.settings.hyphenation != this.hyphenation()) {
            var modal = $("#readerSettings")[0];
            if (modal) {
                app.f7.closeModal(modal);
            }
            window.location.reload();
            this.isLoading(true);
        }
        this.settings = {
            brightness: this.brightness(),
            fontSize: this.fontSize(),
            fieldSize: this.fieldSize(),
            lineHeight: this.lineHeight(),
            fontFamily: this.fontFamily(),
            readerMode: this.readerMode(),
            customColorScheme: this.customColorScheme(),
            customFontColor: this.customFontColor(),
            customBackgroundColor: this.customBackgroundColor(),
            version: "1.1",
            hyphenation: this.hyphenation()
        };
        localStorageUtils_1.default.set("reader.settings", this.settings);
    };
    ViewModel.prototype.cleanHtmlColors = function (html) {
        return html.replace(/color\s*:\s*windowtext\s*;?/gi, "");
    };
    ViewModel.prototype.loadChapter = function (id, lastPage, chapterProgress) {
        var _this = this;
        if (lastPage === void 0) { lastPage = false; }
        if (chapterProgress === void 0) { chapterProgress = null; }
        this.isLoading(true);
        var modal = $(".popup.modal-in")[0];
        if (modal) {
            app.f7.closeModal(modal);
        }
        try {
            if (this.isInit) {
                if (history && history.pushState) {
                    history.pushState({ chapterId: id }, "", app.rootUrl + ("reader/" + this.workId + "/" + id));
                }
            }
        }
        catch (ex) {
            try {
                console.error(ex);
            }
            catch (ex) { }
        }
        $("#text-container").empty();
        var readTextLength = 0;
        var chapters = this.chapters();
        for (var i = 0; i < chapters.length; i++) {
            var c = chapters[i];
            if (c.id === id) {
                break;
            }
            readTextLength += c.textLength;
        }
        this.readTextLength(readTextLength);
        ajaxUtils_1.AjaxUtils.get("reader/" + this.workId + "/chapter", {
            id: id
        })
            .done(function (result, textStatus, jqXHR) {
            if (!result.isSuccessful) {
                if (result.messages && result.messages.length) {
                    if (result.messages[0] === "Suspended") {
                        _this.showSuspendedForm(true);
                        _this.isLoading(false);
                        return;
                    }
                    if (result.messages[0] === "Unauthorized") {
                        _this.showUnauthorizedForm(true);
                        _this.isLoading(false);
                        return;
                    }
                    if (result.messages[0] === "Paid") {
                        _this.price = result.data.price;
                        _this.discount = result.data.discount;
                        _this.priceWithDiscounts(result.data.priceWithDiscounts);
                        _this.discountEnd = result.data.discountEnd;
                        _this.showBuyForm(true);
                        _this.isLoading(false);
                        return;
                    }
                    if (result.messages[0] === "Unadulted") {
                        _this.showUnadultedForm(true);
                        _this.isLoading(false);
                        return;
                    }
                    alert(result.messages[0]);
                    return;
                }
            }
            var secret = jqXHR.getResponseHeader("Reader-Secret");
            var userId = window["app"].userId || "";
            var key = secret.split("").reverse().join("") + "@_@" + userId;
            var text = _.map(result.data.text, function (c, i) {
                return String.fromCharCode(result.data.text.charCodeAt(i) ^ key.charCodeAt(Math.floor(i % key.length)));
            })
                .join("");
            text = _this.cleanHtmlColors(text);
            var headerText;
            if (_this.workForm === "Story") {
                headerText = _this.workTitle;
            }
            else {
                headerText = _this.currentChapter().title;
            }
            if (_this.workForm !== "Story") {
                document.title = "\u041A\u043D\u0438\u0433\u0430 " + _this.workTitle + ", " + _this.currentChapter().title + ", " + _this.authorName + " \u0447\u0438\u0442\u0430\u0442\u044C \u043E\u043D\u043B\u0430\u0439\u043D";
            }
            else {
                document.title = _this.workTitle + ", " + _this.authorName + " \u0447\u0438\u0442\u0430\u0442\u044C \u043E\u043D\u043B\u0430\u0439\u043D";
            }
            var header = "<h1>" + headerText + "</h1>";
            if (result.data.warningNeuralNetworks) {
                header += "<p class=\"text-neural-networks\"><i class=\"icon-neural-networks\"></i>\u0421\u043E\u0437\u0434\u0430\u043D\u043E \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u0438</p><hr />";
            }
            if (_this.epilog && !_this.nextChapter()) {
                text += "<hr /><p style='text-indent: 0'><b>\u041E\u0442 \u0430\u0432\u0442\u043E\u0440\u0430</b></p>" + _this.epilog;
            }
            $("#text-container").html(header + text);
            setTimeout(function () {
                _this.isLoading(false);
                try {
                    var photoBrowserNavbarTemplate = $("#photoBrowserNavbarTemplate").html();
                    $("#text-container").find("img:not(.emojione,.img-gif,.gif-preview-img)").each(function (i, el) {
                        var $img = $(el);
                        $img.on("click", function (ev) {
                            try {
                                var pb = $img.data("photoBrowser");
                                if (pb) {
                                    pb.open();
                                    return;
                                }
                                ;
                                pb = app.f7.photoBrowser({
                                    maxZoom: 3,
                                    swipeToClose: false,
                                    //type: "popup",
                                    navbar: true,
                                    navbarTemplate: photoBrowserNavbarTemplate,
                                    exposition: false,
                                    toolbar: false,
                                    backLinkText: "Назад",
                                    photos: [$img.attr("src")]
                                });
                                $img.data("photoBrowser", pb);
                                pb.open();
                            }
                            catch (ex) { }
                        });
                    });
                    if (app.isAuthenticated) {
                        setTimeout(function () {
                            _this.updateReadingProgress();
                        }, 10000);
                    }
                }
                catch (ex) { }
            }, 100);
            if (chapterProgress > 5) {
                app.f7.modal({
                    text: "Перейти к последнему месту чтения?",
                    buttons: [
                        {
                            text: "Да",
                            bold: true,
                            onClick: function () {
                                var percent = chapterProgress / 100;
                                var height = $("#text-container").height();
                                _this.$reader.animate({ scrollTop: height * percent }, "fast");
                                _this.chapterProgressPercent(percent);
                            }
                        },
                        {
                            text: "Нет"
                        }
                    ]
                });
            }
        });
    };
    ViewModel.prototype.updateReadingProgress = function () {
        var _this = this;
        var data = {
            wId: this.workId,
            cId: this.currentChapterId(),
            wp: this.progressPercent(),
            cp: this.chapterProgressPercent() * 100,
            sId: this.sessionId,
            aa: app.isAuthenticated && !this.libraryId()
        };
        if (this.readerMode() === "scroll") {
            var height = $("#text-container").height();
            var scrollTop = this.$reader.scrollTop();
            data.cp = scrollTop / height * 100;
        }
        if (app.userId) {
            readingProgressUtils_1.default.updateIfNeeded(app.userId, data.wId, data.cId, data.cp, data.wp, data.sId);
        }
        ajaxUtils_1.AjaxUtils.post(app.statsApiUrl + "reader/update-progress?" + $.param(data), null, true)
            .done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
                return;
            }
            if (result.data && result.data.newLibraryId) {
                app.f7.addNotification({
                    message: "Произведение добавлено в вашу библиотеку.",
                    hold: 5000,
                    button: {
                        text: "OK",
                    }
                });
                try {
                    metrikaUtils_1.default.reachGoal("addToLibrary", { workId: _this.workId, state: "Reading", inReader: true });
                }
                catch (ex) { }
            }
        });
    };
    ViewModel.prototype.increaseBrightness = function () {
        var brightness = this.brightness() + 1;
        if (brightness <= this.maxBrightness) {
            this.brightness(brightness);
        }
    };
    ViewModel.prototype.decreaseBrightness = function () {
        var brightness = this.brightness() - 1;
        if (brightness >= this.minBrightness) {
            this.brightness(brightness);
        }
    };
    ViewModel.prototype.increaseFontSize = function () {
        var fontSize = this.fontSize() + 1;
        if (fontSize <= this.maxFontSize) {
            this.fontSize(fontSize);
        }
    };
    ViewModel.prototype.decreaseFontSize = function () {
        var fontSize = this.fontSize() - 1;
        if (fontSize >= this.minFontSize) {
            this.fontSize(fontSize);
        }
    };
    ViewModel.prototype.nextFont = function () {
        var fontIndex = this.fontList.indexOf(this.fontFamily());
        fontIndex = fontIndex < this.fontList.length - 1 ? fontIndex + 1 : 0;
        this.fontFamily(this.fontList[fontIndex]);
    };
    ViewModel.prototype.previousFont = function () {
        var fontIndex = this.fontList.indexOf(this.fontFamily());
        fontIndex = fontIndex === 0 ? this.fontList.length - 1 : fontIndex - 1;
        this.fontFamily(this.fontList[fontIndex]);
    };
    ViewModel.prototype.toggleWorkInfoMode = function () {
        this.workInfoMode("comments");
        commentUtils_1.default.init(null);
    };
    ViewModel.prototype.toggleFullScreen = function () {
        screenfull.toggle();
    };
    ViewModel.prototype.showAllMarks = function (model, ev) {
        var _this = this;
        var popover = this.$markPopover[0];
        if (popover) {
            this.$morePopover.hasClass("modal-in") && app.f7.closeModal(this.$morePopover[0]);
            app.f7.popover(popover, ev.currentTarget);
            window.history && window.history.pushState("forward", null, "");
            this.backHistoryAfterClose = true;
            this.$markPopover.one('popover:closed', function () {
                if (_this.backHistoryAfterClose) {
                    window.history && window.history.back();
                }
            });
        }
    };
    ViewModel.prototype.closeMarkPopover = function () {
        this.$markPopover.hasClass("modal-in") && app.f7.closeModal(this.$markPopover[0]);
    };
    ViewModel.prototype.setAdultCookie = function () {
        cookieUtils_1.default.setAdultUser();
        this.showUnadultedForm(false);
        this.loadChapter(this.currentChapterId);
    };
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=readerIndex.js.map